import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import { GlobalFooterBottom } from "@/patterns/global-footer/src";

import { AgileFooterTop } from "./agile-footer-top";

// ==================================================================
// CSS styling
// ==================================================================
const agileFooterStyles = css({
    "alignItems": "center",
    "background": "#f4f5f7",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".globalFooterContentContainer": {
        backgroundColor: "#f4f5f7",
        paddingBlock: token("space.200"),
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginInline: "24px",

        [media.above.md]: {
            display: "flex",
            maxWidth: "1200px",
            paddingInline: "0",
            marginInline: "60px"
        }
    }
});

// ==================================================================
// Type Props
// ==================================================================
export type AgileFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const AgileFooter = ({
    selectedLanguage,
    onLanguageChangeHandler
}: AgileFooterPatternProps) => (
    <UFOSegment name="agile-footer-v2">
        <footer css={agileFooterStyles}>
            <div className="globalFooterContentContainer">
                <AgileFooterTop />
                <GlobalFooterBottom
                    selectedLanguage={selectedLanguage}
                    onLanguageChangeHandler={onLanguageChangeHandler}
                />
            </div>
        </footer>
    </UFOSegment>
);
